import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5568977a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel" }

import { computed } from 'vue'

interface Props {
  field: string
}


export default /*#__PURE__*/_defineComponent({
  props: {
    field: null
  },
  setup(__props: any) {

const props = __props as {
  field: string
}



const panelClass = computed(() => {
  if (props.field.includes('rain')) {
    return 'rain'
  }
  if (props.field.includes('water_level')) {
    return 'water-level'
  }

  return ''
})

const panelStyle = computed(() => {
  if (!props.field.includes('water_level')) {
    return {}
  }

  return {
    backgroundImage: 'url("/cdn_images/image/map/water_legend.png")',
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(_unref(panelClass)),
      style: _normalizeStyle(_unref(panelStyle))
    }, null, 6)
  ]))
}
}

})